function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12.0273C0 5.40056 5.37321 0.0273438 12 0.0273438C18.6268 0.0273438 24 5.40056 24 12.0273C24 18.6541 18.6268 24.0273 12 24.0273C5.37321 24.0273 0 18.6541 0 12.0273ZM2.03571 12.0273C2.03571 17.5291 6.49821 21.9916 12 21.9916C17.5018 21.9916 21.9643 17.5291 21.9643 12.0273C21.9643 6.52556 17.5018 2.06306 12 2.06306C6.49821 2.06306 2.03571 6.52556 2.03571 12.0273ZM16.43 7.5771C16.5478 7.5771 16.6443 7.67353 16.6443 7.79139C16.6443 7.84228 16.6282 7.89318 16.5961 7.93068L13.1112 12.0825L16.5907 16.2316C16.6229 16.2717 16.6416 16.32 16.6416 16.3709C16.6416 16.4914 16.5452 16.5851 16.4273 16.5851L14.6595 16.5771L11.9996 13.4057L9.33981 16.5798L7.56928 16.5878C7.45142 16.5878 7.35499 16.4914 7.35499 16.3735C7.35556 16.3227 7.37352 16.2735 7.40588 16.2342L10.8907 12.0851L7.40588 7.93335C7.37374 7.89318 7.35499 7.84496 7.35499 7.79407C7.35499 7.67353 7.45142 7.57978 7.56928 7.57978L9.33981 7.58782L11.9996 10.7592L14.6621 7.58514L16.43 7.5771Z",
  fill: "var(--k-fg-f03738)"
});

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e74a8511.svg";
export { ForwardRef as ReactComponent };